module.exports = __webpack_public_path__ + "img/lecce_4.907ae621.png";